"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonalCardSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _NoUserImage = _interopRequireDefault(require("./NoUserImage"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Personal info card skeleton to be displayed when PersonalCard data is being loaded.
 * The skeleton is a separate component to be replaced by the final PersonalCard when
 * the data loading is complete.
 * @param props PersonalCardSkeletonProps
 * @returns JSX.Element
 */
const PersonalCardSkeleton = ({
  className,
  label,
  testId
}) => {
  const ownerState = {
    isOnlyFirstRow: true
  };
  const addressWrapperProps = {
    ownerState
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": testId,
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      variant: "h6",
      component: "p",
      children: label
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AddressWrapper, {
      ...addressWrapperProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_NoUserImage.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        height: 13,
        variant: "rectangular",
        width: 140
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContactsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContactsRow, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
          height: 21,
          variant: "rounded",
          width: 21
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
          height: 13,
          variant: "rectangular",
          width: 200
        })]
      })
    })]
  });
};
exports.PersonalCardSkeleton = PersonalCardSkeleton;
var _default = exports.default = PersonalCardSkeleton;
